function calcProgress(answers) {
  return answers.length;
}

function calcTotal(questions) {
  let total = 0;
  let values = Object.values(questions);
  values.forEach((value) => {
    let sub_values = Object.values(value);
    sub_values.forEach((sub_value) => {
      if (sub_value) {
        console.log(sub_value);
        total += Object.values(sub_value).length;
      }
    });
  });

  return total;
}

export default {
  calcProgress,
  calcTotal,
};
